<div
  class="info-box info-box--{{ type() }}"
  [ngClass]="type"
  [attr.role]="ariaRole()"
>
  <div
    class="info-header"
    (click)="toggleCollapse()"
    (keydown.enter)="toggleCollapse()"
    [attr.aria-label]="title()"
  >
    <i class="icon icon-info is-size-6 has-text-info ml-1"></i>
    <h2 class="info-title">{{ title() }}</h2>

    <div class="info-actions mb-1">
      @if(collapsed()) {
      <i class="icon icon-chevron-down mr-1"></i>
      } @else {
      <i class="icon icon-chevron-up mr-1"></i>
      }
    </div>
  </div>

  @if(!collapsed()) {
  <div class="info-body" [attr.aria-hidden]="collapsed()">
    <div [innerHtml]="content()"></div>
  </div>
  }
</div>
